import taskManager from "./assets/TicketAndTaskManager.png";
import todoList from "./assets/ToDoList.png";
import atm from "./assets/ATM.png";
import characterAnalysis from "./assets/CharacterAnalysis.png";
import { Project } from "./Project";

export default function PeronsalProjects() {
  return (
    <div class="project-container" id="projects">
      <div>
        <h2 class="container-title">Personal Projects</h2>
      </div>
      <div class="project-list">
        <Project 
          name={"Character Analysis"} 
          link={"https://github.com/ThereaultL/CharacterAnalysis"} 
          img={characterAnalysis}
          overview={"Analyzes a text file to identify all character names "+
            "mentioned in the text and counts how many times each one appears."+
            " It also detects dialogue by iterating through the file and "+
            "applying simple speech-pattern rules. Using English grammar cues,"+
            " the program infers which character is speaking in each line of "+
            "dialogue. For every character who speaks, the program extracts a "+
            "catchphrase by determining the most frequently used word in their"+
            " speech, excluding pronouns, articles, and prepositions."}
          stack={["Python", "File Parsing", "Text Analysis", "Data Analysis"]}
        />
        <Project 
          name={"Ticket and Task Manager"}
          link={"https://github.com/ThereaultL/TicketAndTaskManager"}
          img={taskManager}
          overview={"A simplified of Jira or Trello for managing tickets "+
            "(issues, bugs, tasks). Users can create, view, edit, update, and "+
            "resolve/delete tickets with details like title, description, and "+
            "status."}
          stack={["React.js", "Node.js", "Express.js", "REST API", "JavaScript"]}
        />
        <Project 
          name={"ToDo List"}
          link={"https://github.com/ThereaultL/ToDo-DesktopApp"}
          img={todoList}
          overview={"A basic ToDo list desktop application that allows users "+
            "to create, view, and complete tasks. Users tasks are saved to "+
            "their account and can be accessed from any device upon logon."}
          stack={["React.js", "Node.js", "Electron.js", "Express.js", "JavaScript", "SQL"]}
        />
        <Project 
          name={"ATM"}
          link={"https://github.com/ThereaultL/ATM"}
          img={atm}
          overview={"A console based ATM simulator that allows users to "+
            "perform basic banking operations such as checking balance, "+
            "depositing, withdrawing, and transferring funds. It simulates a "+
            "real ATM experience with user authentication and admin "+
            "functionality. Security measures are implemented to prevent users"+
            " from overdrafting their accounts or pulling out more money than "+
            "is readily available inside of the ATM."}
            stack={["Java", "OOP", "Data Handeling"]}
        />
      </div>
    </div>
  );
}
